import type { ChecklistAnswer, ChecklistAnswerResponse } from "../types";

type ChecklistAnswerUpdate = {
	checklistAnswer: ChecklistAnswer;
} & Partial<Omit<ChecklistAnswerResponse, "checklistAnswer">>;

export function mergeChecklistAnswerResponse(
	previous: ChecklistAnswerResponse | null | undefined,
	update: ChecklistAnswerUpdate
): ChecklistAnswerResponse {
	return {
		initializeMode:
			update.initializeMode ?? previous?.initializeMode ?? "NewAnswer",
		answerInProgress:
			update.answerInProgress ?? previous?.answerInProgress ?? true,
		isTrailerOrSemiTrailer:
			update.isTrailerOrSemiTrailer ??
			previous?.isTrailerOrSemiTrailer ??
			false,
		summary: update.summary ?? previous?.summary,
		checklistAnswer: update.checklistAnswer,
	};
}
